module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/seperation-phone-2.83e8e62d.png";